import { createAction } from 'redux-actions';
import { instance } from "../../../config/interceptor";

export const cleanupAction = createAction('CLEANUP_EXTERNAL_AUDIT_DASBOARD');

export const cleanup = ()  => async (dispatch) => {
  dispatch(cleanupAction());
}

export const getSurveysRequest = createAction('EXTERNAL_AUDIT_DASBOARD_GET_SURVEYS_REQUEST');
export const getSurveysSuccess = createAction('EXTERNAL_AUDIT_DASBOARD_GET_SURVEYS_SUCCESS');
export const getSurveysError = createAction('EXTERNAL_AUDIT_DASBOARD_GET_SURVEYS_ERROR');

export const getSurveys = () => async (dispatch) => {
  try {
    dispatch(getSurveysRequest());
    const resp = await instance.get(`/v1/Survey/GetListByLibrary`);
    
    dispatch(getSurveysSuccess(resp.data));

  } catch (e) {
    if(e.response && e.response.data && e.response.data.description)
      dispatch(getSurveysError(e.response.data.description));
    else
      dispatch(getSurveysError(e.message));
  }
};